import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import Layout from "@/components/layout/Layout";
import api from "@/lib/api";
import { useMall } from "@/context/MallContext";
import SimpleHome from "@/components/simple/SimpleHome";
import UnknownShop from "@/pages/simple/UnknownShop";

/** /stores/:slug — that shop's home page: hero banner + the product grid. An unknown slug gets the "isn't open yet" screen. */
export default function StorePage({ slug: fixed }) {
    const { slug: param } = useParams();
    const slug = fixed || param;
    const { enter } = useMall();
    const [site, setSite] = useState(null);
    const [err, setErr] = useState(false);

    useEffect(() => {
        setSite(null);
        setErr(false);
        api.get(`/stores/site/${slug}`).then(({ data }) => {
            setSite(data);
            enter({ ...data.store, designers: data.store.designers ?? data.store.designers_enabled }, "store");
        }).catch(() => setErr(true));
    }, [slug, enter]);

    if (err) return <UnknownShop slug={slug} />;
    if (!site) return <Layout><div className="flex justify-center py-32"><Loader2 className="animate-spin text-zinc-400" /></div></Layout>;
    return <Layout title="Order"><SimpleHome store={site.store} /></Layout>;
}
